class CountdownShipping extends	HTMLElement {
	constructor( )
	{
		super( );
		this.formatCountdown.bind( this );
		this.formatCutoff.bind( this );
		this.initCountdownShipping.bind( this );
		this.updateCountdown.bind( this );
	}

	connectedCallback( )
	{
		document.addEventListener( "DOMContentLoaded", this.initCountdownShipping.bind( this ) );
	}

	// Helper to format time as 03:20:05
	formatCountdown( totalSeconds )
	{
		const hours   = Math.floor( totalSeconds / 3600 );
		const minutes = Math.floor( ( totalSeconds % 3600 ) / 60 );
		const seconds = Math.floor( totalSeconds % 60 );
		return `${ String( hours ).padStart( 2, '0' ) }:${ String( minutes ).padStart( 2, '0' ) }:${ String( seconds ).padStart( 2, '0' ) }`;
	}

	// Helper to format the cutoff time as "6pm" or "18:00"
	formatCutoff( date )
	{
		let hours     = date.getHours( );
		const minutes = date.getMinutes( );
		const ampm    = hours >= 12 ? 'pm' : 'am';
		hours         = hours % 12;
		hours         = hours ? hours : 12;
		return `${ hours }${ minutes === 0 ? '' : ':' + String( minutes ).padStart( 2, '0' )}${ ampm }`;
	}

	updateCountdown( )
	{
		const now       = new Date( );
		const day       = now.getDay( ); // 0 = Sunday, 6 = Saturday
		const isWeekend = ( day === 0 || day === 6 );

		let targetTime;
		let message          = '';
		let showTimer        = true;
		let msgTemplate      = '';
		let cutoffTimeString = '';

		if ( isWeekend )
		{
			message   = this.weekendMsg;
			showTimer = false;
		}
		else
		{
			// Weekday logic
			// Parse cutoff times
			const [ rmHour, rmMinute, rmSecond ] = this.rmCutoff.split( ':' ).map( Number );
			const rmCutoffDate                   = new Date( now );
			rmCutoffDate.setHours( rmHour, rmMinute, rmSecond, 0 );

			const [evriHour, evriMinute, evriSecond] = this.evriCutoff.split(':').map(Number);
			const evriCutoffDate                     = new Date(now);
			evriCutoffDate.setHours( evriHour, evriMinute, evriSecond, 0 );

			if ( now < rmCutoffDate )
			{
				targetTime       = rmCutoffDate;
				msgTemplate      = this.rmMsg;
				cutoffTimeString = this.formatCutoff( rmCutoffDate );

			}
			else if
			( now < evriCutoffDate )
			{
				targetTime       = evriCutoffDate;
				msgTemplate      = this.evriMsg;
				cutoffTimeString = this.formatCutoff(evriCutoffDate);

			}
			else
			{
				// After all cutoffs for the day
				message   = this.weekdayMsg;
				showTimer = false;
			}
		}

		// Replace {countdown} and {cutoff}  in message template
		if ( showTimer && targetTime && msgTemplate )
		{
			const totalSeconds = Math.floor( ( targetTime - now ) / 1000 );
			if ( totalSeconds > 0 )
			{
				// Replace placeholders
				const countdownStr = this.formatCountdown( totalSeconds );

				// Replace {countdown} and {highlighted_text} with a styled span
				let messageWithCountdown = msgTemplate
					.replace(
						'{countdown}',
						`<span style="color: ${this.countdownColor}; font-weight: ${this.countdownFontWeight};">${countdownStr}</span>`
					)
					.replace(
						'{highlighted_text}',
						`<span style="color: ${this.highlightMsgColor}; font-weight: ${this.highlightMsgFontWeight};">${this.highlightedText}</span>`
					);

				message = messageWithCountdown;

				// Insert the message as HTML so the span is rendered
				this.messageElement.innerHTML   = message;
				this.timerElement.style.display = 'none'; // Timer is now inside the message
				return;
			}
			else
			{
				// If time has just passed
				message   = this.weekdayMsg;
				showTimer = false;
			}
		}

		// Update the message text (no countdown)
		this.messageElement.textContent = message;
		this.timerElement.style.display = 'none'; // Always hide the old timer
	};

	initCountdownShipping( )
	{
		this.rmMsg                  = this.dataset.rmMsg;
		this.evriMsg                = this.dataset.evriMsg;
		this.weekdayMsg             = this.dataset.weekdayMsg;
		this.weekendMsg             = this.dataset.weekendMsg;
		this.rmCutoff               = this.dataset.rmCutoff;
		this.evriCutoff             = this.dataset.evriCutoff;
		this.countdownColor         = this.dataset.countdownColor;
		this.countdownFontWeight    = this.dataset.countdownFontWeight;
		this.highlightedText        = this.dataset.highlightedText; // This is the value to replace {highlighted_text} in the message template
		this.highlightMsgColor      = this.dataset.highlightMsgColor;
		this.highlightMsgFontWeight = this.dataset.highlightMsgFontWeight;
		this.messageElement         = this.querySelector( '.shipping-message' );
		this.timerElement           = this.querySelector( '.countdown-timer' );

		if ( !this.messageElement || !this.timerElement )
		{
			console.error( 'Countdown block is missing a .shipping-message or .countdown-timer element.', this );
			return;
		}

		this.updateCountdown( );
		setInterval( this.updateCountdown.bind( this ), 1000 );
	}
};

if ( !customElements.get( 'countdown-shipping' ) )
{
	customElements.define( 'countdown-shipping', CountdownShipping );
}